// Account Receivable Payments States

export default {
  paymentsList: [],
  paymentInfo: {}
}
